@if (car) {
  <div class="listing-frame listing-map-frame" [class.listing-sponsored]="isSponsered()">
    <span
      class="listing-legend"
      [class.listing-legend-hidden]="!isSponsered()"
      [attr.aria-hidden]="!isSponsered()"
    >
      {{ 'SPONSORED' | translate }}
    </span>
    <button
      type="button"
      class="map-card-close"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="onClose($event)"
      (keydown)="$event.stopPropagation()"
    >
      <i class="bi bi-x" aria-hidden="true"></i>
    </button>

    <div
      class="card listing-card clickable-card cursor-poiner car-popup-card"
      role="link"
      tabindex="0"
      (keydown.enter)="$event.target === $event.currentTarget && goToDetails(car.id)"
      (click)="goToDetails(car.id)"
    >
      <div class="card popup-card">
        <div class="row g-0">
          <div class="col-6">
            <car-images-carousel
              #images
              [displayLikeButton]="false"
              [listingCard]="true"
              [car]="car"
              [carouselId]="listId()"
            ></car-images-carousel>
          </div>
          <div class="col-6 px-2 listing-map-details">
            <div class="d-flex justify-content-between">
              <div class="listing-title-row">
                <h6 class="card-title">
                  <app-brand-logo [icon]="car.model"></app-brand-logo>{{ car.model }} -
                  {{ car.name }}
                </h6>
                @if (!car.isExpired && car.status !== statuses.Sold) {
                  <button
                    type="button"
                    class="listing-favorite"
                    [attr.aria-pressed]="images.isLiked()"
                    [attr.aria-label]="
                      (images.isLiked() ? 'REMOVE_FROM_FAVORITES' : 'ADD_TO_FAVORITES') | translate
                    "
                    (click)="images.toggleLike($event)"
                    (keydown)="$event.stopPropagation()"
                  >
                    <i
                      [class]="images.isLiked() ? 'bi bi-heart-fill' : 'bi bi-heart'"
                      aria-hidden="true"
                    ></i>
                  </button>
                }
              </div>
            </div>
            <div class="row car-specs">
              <div class="col-6">
                <p class="card-text">
                  <i class="bi bi-fuel-pump px-1 no-icon"></i>{{ car.fuel | translate }}
                </p>
              </div>
              <div class="col-6 no-icon">
                <p class="card-text">
                  <i class="bi bi-speedometer px-1"></i>{{ car.kilometers | number: '1.0-0' }}
                </p>
              </div>
              <div class="col-6">
                <p class="card-text">
                  <i class="bi bi-calendar-event px-1 no-icon"></i> {{ car.year }}
                </p>
              </div>
              <div class="col-6 no-icon">
                @if (car.city) {
                  <p class="card-text">
                    <i class="bi bi-geo-alt-fill px-1 no-icon"></i>

                    <span>{{ car.city | syrianCity }}</span>
                  </p>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
